// src/components/Help/helpContent.js

export const helpContent = {
    pageTitle: "Help & Support",
    systemStatus: {
        title: "System Status",
        statuses: [
            { id: 'app_ui', name: 'Application UI', status: 'Operational' },
            { id: 'api', name: 'API Services', status: 'Operational' },
            { id: 'search', name: 'Passive Search', status: 'Operational' },
            { id: 'billing', name: 'Billing Systems', status: 'Operational' },
        ]
    },
    quickLinks: {
        title: "Quick Help",
        links: [
            { 
                id: 'link-1', 
                title: 'Getting Started Guide', 
                description: 'New to the app? Start here.', 
                icon: 'RocketLaunchIcon', 
                type: 'dialog',
                content: {
                    title: 'Getting Started Guide',
                    body: "Welcome to Candidate Tools! To get started, create your first Ideal Candidate Profile by clicking the 'New Profile' button on the main dashboard. This profile acts as a blueprint for your perfect candidate, defining the skills and behaviors our system will use to score and rank applicants."
                }
            },
            { 
                id: 'link-2', 
                title: 'Understanding Your Bill', 
                description: 'Learn about our pricing and plans.', 
                icon: 'ReceiptLongIcon',
                type: 'dialog',
                content: {
                    title: 'Understanding Your Bill',
                    body: "All billing and subscription management is handled through our secure Stripe Customer Portal. You can access the portal from Settings > Payments. There, you can view and download past invoices, update your payment method, and change or cancel your plan at any time."
                }
            },
            { 
                id: 'link-3', 
                title: 'How to Create a Profile', 
                description: 'A step-by-step guide.', 
                icon: 'PersonAddIcon',
                type: 'navigate', // This one will still navigate
                path: '/ideal-candidates'
            },
        ]
    },
    faq: {
        title: "Frequently Asked Questions",
        categories: [
            {
                id: "cat-1",
                name: "Account & Security",
                questions: [
                    { id: "faq-1", question: "How do I change my password?", answer: "You can change your password by navigating to the Settings page, selecting the 'Security' tab, and using the 'Change Password' form. You will need to enter your current password and a new password." },
                    { id: "faq-2", question: "How do I enable Two-Factor Authentication (2FA)?", answer: "In the 'Security' tab of your settings, you can find the Two-Factor Authentication section. Click 'Enable 2FA' and follow the on-screen instructions to set it up with your authenticator app." },
                ]
            },
            {
                id: "cat-2",
                name: "Billing & Subscriptions",
                questions: [
                    { id: "faq-3", question: "How do I manage my subscription or view invoices?", answer: "You can manage your subscription, view past invoices, and update your payment methods by going to Settings > Payments and clicking the 'Manage Subscription' button. This will open our secure customer portal powered by Stripe." },
                    { id: "faq-4", question: "Where can I find my Organization ID?", answer: "Your Organization ID is visible in the 'Organization' tab of the Settings page. It's useful when contacting support as it helps us identify your account quickly." },
                ]
            },
            {
                id: "cat-3",
                name: "Using The App",
                questions: [
                    { id: "faq-5", question: "What is the difference between a Skill Score and a Behavior Score?", answer: "The Skill Score measures a candidate's proficiency in the specific hard skills required for the job (e.g., programming languages, marketing tools). The Behavior Score assesses a candidate's alignment with the soft skills and work styles you've defined as important for your team." },
                    { id: "faq-6", question: "How does the 'Passive Search' feature work?", answer: "Passive Search allows you to find potential candidates from a broader talent pool, not just those who have directly applied. You provide a job description or a set of keywords, and our system searches for matching profiles, scores them, and presents you with a ranked list of potential fits." }
                ]
            }
        ]
    },
    ticket: {
        title: "Submit a Support Ticket",
        description: "Can't find an answer? Our team is here to help.",
        subjectLabel: "Subject",
        descriptionLabel: "Please describe the issue in detail",
        attachmentLabel: "Attach a file (optional)",
        buttonText: "Submit Ticket",
        loadingText: "Submitting...",
        successMessage: "Your support ticket has been submitted successfully!",
    }
};
